/**
 * Switch tabIndex attribute for all links inside wrapper
 * @param {Element} wrapper
 * @param {string} tabIndex
 * @param {number} delay
 */
export default function switchLinksTabIndex(wrapper, tabIndex, delay = 0) {
  const focusableElements = [
    ...wrapper.querySelectorAll(
      'a[href], button, input, textarea, select, details, div[tabindex]',
    ),
  ];

  if (delay > 0) {
    setTimeout(() => {
      focusableElements.forEach((el) => {
        el.setAttribute('tabindex', tabIndex);
      });
    }, delay);
  } else {
    focusableElements.forEach((el) => {
      el.setAttribute('tabindex', tabIndex);
    });
  }
}
